import { render, staticRenderFns } from "./ListFamily.vue?vue&type=template&id=2f0dc595&"
import script from "./ListFamily.vue?vue&type=script&lang=js&"
export * from "./ListFamily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports